export class TwDocumentoSolicitudCamBase {
    public Id?: number | null;
    public IdSolicitudCam: number;
    public IdDocumentacionCam: number;
    public NombreArchivo: string;
    public CodigoStorage: string;
    public Descripcion: string;
    public FileSize: number;
    public IdUsuario?: number | null;
    public FechaCreacion?: Date | null;
    public MarkToDelete?: number;
}
export class DocumentoSolicitudCamViewModel extends TwDocumentoSolicitudCamBase {
    public IdCampania: number;
    public IdTipoDocumentacion: number;
    public Obligatoria: boolean;
    public TipoDocumentacion: string;
}

export enum TipoAdjunto {
    PDF = 1,
    DOC = 2,
    DOCX = 3,
    JPG = 4,
    TIFF = 5,
    JPEG = 6,
}

export class DocSolicitudCamIndex {
    adjunto: TwDocumentoSolicitudCamBase;
    index: number;
}

export enum EditionMode {
    Creation = 'Creation',
    Edition = 'Edition',
}
